import { useEffect, useState } from 'react';
import { TextField } from '../../ui/core';

// Debounced name/email/phone search, following PersonSearchField's effect
// (500ms setTimeout, cleanup flips `active` false + clears the timer so a
// superseded keystroke's timer can't fire after a newer one already has).
const ClaimsSearchBar = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    let active = true;
    const timer = setTimeout(() => {
      if (active) onSearch(inputValue.trim());
    }, 500);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [inputValue, onSearch]);

  return (
    <TextField
      sx={{ width: '100%' }}
      placeholder="Search driver name, email, or phone"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
    />
  );
};

export default ClaimsSearchBar;
